module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuMTY2OTkgOS45OTk5NkgxNS44MzM3TTE1LjgzMzcgOS45OTk5NkwxMC4wMDAzIDQuMTY2NjNNMTUuODMzNyA5Ljk5OTk2TDEwLjAwMDMgMTUuODMzMyIgc3Ryb2tlPSIjMjEwNDJFIiBzdHJva2Utd2lkdGg9IjEuNjY2NjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/icon/svg/blog_arrow_right.svg
// module id = SlbP
// module chunks = 8